module.exports = __webpack_public_path__ + "img/red.a2805837.png";